import PerformanceComparisonBase from './../../PerformanceComparisonBase.js';
import * as Enums from './../../../../enums/index.js';

const mphToMs = Enums.ImperialToSiConversion.MPH_MPS.ratio;
const inchToM = Enums.ImperialToSiConversion.IN_M.ratio;
const pitcherMlb = new PerformanceComparisonBase(Enums.BaseballPitchType, Enums.PitchData, 'MLB - 2019');

// max values are based on previous research for data sanitization
// for speed https://docs.google.com/document/d/1xbRySES57yygj-AaSbWViNWlcQnJqnzt6pCHOoVPv9E/edit#heading=h.w36vlc7g8pgc
// for spin https://docs.google.com/document/d/1xbRySES57yygj-AaSbWViNWlcQnJqnzt6pCHOoVPv9E/edit#
// and MLB data 
// movement https://docs.google.com/spreadsheets/d/1wr1yUS6HXH_7intowlWHTlWoqEF1Ddq9vs97sKN5G6g/edit#
// speed https://docs.google.com/spreadsheets/d/1AYG2yeFzEVgrcCcpxjGnjrHlKfPzwt5O9ki3wliUBp4/edit#
// spin https://docs.google.com/spreadsheets/d/1fvZZfnSIZFhC8kCl7RTJmMfnbb7GRAPXs7FWSL2nQkg/edit#

// FourSeamFastball - FF
// see https://baseballsavant.mlb.com/pitch-arsenals?year=2019&min=50&type=avg_speed&hand=&sort=1&sortDir=desc
// https://docs.google.com/spreadsheets/d/1AYG2yeFzEVgrcCcpxjGnjrHlKfPzwt5O9ki3wliUBp4/edit#gid=45617823&range=D1:D2
pitcherMlb.set(Enums.BaseballPitchType.FourSeamFastball.key, Enums.PitchData.Speed.key, 93.2 * mphToMs, 100.9 * mphToMs);

// https://baseballsavant.mlb.com/leaderboard/pitch-arsenals?year=2019&min=50&type=avg_spin&hand=
// https://docs.google.com/spreadsheets/d/1fvZZfnSIZFhC8kCl7RTJmMfnbb7GRAPXs7FWSL2nQkg/edit#gid=1077179801&range=D1:D2
pitcherMlb.set(Enums.BaseballPitchType.FourSeamFastball.key, Enums.PitchData.Spin.key, 2271, 2891);

// https://baseballsavant.mlb.com/leaderboard/pitch-movement?year=2019&team=&min=q&pitch_type=FF&hand=&x=diff_x_hidden&z=diff_z_hidden&sort=6&sortDir=asc
// https://docs.google.com/spreadsheets/d/1wr1yUS6HXH_7intowlWHTlWoqEF1Ddq9vs97sKN5G6g/edit#gid=1807171135&range=O1:O2
// pitcherMlb.set(Enums.BaseballPitchType.FourSeamFastball.key, Enums.PitchData.BreakV.key, 16.5 * inchToM,  37.9 * inchToM);

// https://docs.google.com/spreadsheets/d/1giHZnyhB_JApDEjO6I9SAB04ISb20MYNrWPpTmSNf7w/edit#gid=534733429&range=J1:J3
pitcherMlb.set(Enums.BaseballPitchType.FourSeamFastball.key, Enums.PitchData.BreakV.key, -17.2 * inchToM,  -22.9 * inchToM);

// https://baseballsavant.mlb.com/leaderboard/pitch-movement?year=2019&team=&min=q&pitch_type=FF&hand=&x=diff_x_hidden&z=diff_z_hidden&sort=9&sortDir=desc
// https://docs.google.com/spreadsheets/d/1wr1yUS6HXH_7intowlWHTlWoqEF1Ddq9vs97sKN5G6g/edit#gid=1807171135&range=S1:S2
// https://docs.google.com/spreadsheets/d/1giHZnyhB_JApDEjO6I9SAB04ISb20MYNrWPpTmSNf7w/edit#gid=534733429&range=I1:I3
pitcherMlb.set(Enums.BaseballPitchType.FourSeamFastball.key, Enums.PitchData.BreakH.key, 6.3 * inchToM, 10.2 * inchToM);

// Unfortunately we don't have easy access to spin direction data for 2019, 2018 will be used instead, for  use following query
/* SELECT AVG(player_avg), MAX(player_avg) FROM 
(
SELECT AVG(spin_dir) as player_avg --, p_throws
FROM pitches_atbats_games_names 
WHERE 
pitch_type IN (
-- https://docs.google.com/document/d/1PszbMD2JgXitdGb3qnn7RrqXJokpWL1mOZDNbF3FNZI/edit#heading=h.uprl34voahq9
-- 'AB',
-- 'CH',
-- 'CU',
-- 'EP',
-- 'FA',
-- 'FC',
'FF'
-- 'FO',
-- 'FS',
-- 'FT',
-- 'IN',
-- 'KC',
-- 'KN',
-- 'PO',
-- 'SC',
-- 'SI',
-- 'SL',
-- 'UN'
)
AND date LIKE '2018%'
AND p_throws = 'L'
GROUP BY pitcher_id
) */

pitcherMlb.set(Enums.BaseballPitchType.TwoSeamFastball.key, Enums.PitchData.SpinDirection.key, 152.2, 200.3);

// FT - TwoSeamFastball
// see https://baseballsavant.mlb.com/leaderboard/custom?year=2019&type=pitcher&filter=&sort=2&sortDir=desc&min=q&selections=fastball_avg_speed,fastball_avg_spin,fastball_avg_break_x,fastball_avg_break_z,fastball_avg_break,fastball_range_speed,breaking_avg_speed,breaking_avg_spin,breaking_avg_break_x,breaking_avg_break_z,breaking_avg_break,breaking_range_speed,offspeed_avg_speed,offspeed_avg_spin,offspeed_avg_break_x,offspeed_avg_break_z,offspeed_avg_break,offspeed_range_speed,&chart=false&x=fastball_avg_spin&y=fastball_avg_spin&r=no&chartType=beeswarm
pitcherMlb.set(Enums.BaseballPitchType.TwoSeamFastball.key, Enums.PitchData.Speed.key, 93.2, 97.6 * mphToMs);

// https://baseballsavant.mlb.com/leaderboard/custom?year=2019&type=pitcher&filter=&sort=3&sortDir=desc&min=q&selections=fastball_avg_speed,fastball_avg_spin,fastball_avg_break_x,fastball_avg_break_z,fastball_avg_break,fastball_range_speed,breaking_avg_speed,breaking_avg_spin,breaking_avg_break_x,breaking_avg_break_z,breaking_avg_break,breaking_range_speed,offspeed_avg_speed,offspeed_avg_spin,offspeed_avg_break_x,offspeed_avg_break_z,offspeed_avg_break,offspeed_range_speed,&chart=false&x=fastball_avg_spin&y=fastball_avg_spin&r=no&chartType=beeswarm
pitcherMlb.set(Enums.BaseballPitchType.TwoSeamFastball.key, Enums.PitchData.Spin.key, 2120, 2650);

pitcherMlb.set(Enums.BaseballPitchType.TwoSeamFastball.key, Enums.PitchData.SpinDirection.key, 128.5, 164.3);

// ?? https://baseballsavant.mlb.com/leaderboard/custom?year=2019&type=pitcher&filter=&sort=4&sortDir=desc&min=q&selections=fastball_avg_speed,fastball_avg_spin,fastball_avg_break_x,fastball_avg_break_z,fastball_avg_break,fastball_range_speed,breaking_avg_speed,breaking_avg_spin,breaking_avg_break_x,breaking_avg_break_z,breaking_avg_break,breaking_range_speed,offspeed_avg_speed,offspeed_avg_spin,offspeed_avg_break_x,offspeed_avg_break_z,offspeed_avg_break,offspeed_range_speed,&chart=false&x=fastball_avg_spin&y=fastball_avg_spin&r=no&chartType=beeswarm
//pitcherMlb.set(Enums.BaseballPitchType.TwoSeamFastball.key, Enums.PitchData.BreakH.key, 15.5 * inchToM);

// SI Sinker
// https://baseballsavant.mlb.com/pitch-arsenals?year=2019&min=50&type=avg_speed&hand=&sort=2&sortDir=desc
// https://docs.google.com/spreadsheets/d/1AYG2yeFzEVgrcCcpxjGnjrHlKfPzwt5O9ki3wliUBp4/edit#gid=45617823&range=E1:E2
pitcherMlb.set(Enums.BaseballPitchType.Sinker.key, Enums.PitchData.Speed.key, 92.7 * mphToMs, 101.2 * mphToMs);

// https://baseballsavant.mlb.com/leaderboard/pitch-arsenals?year=2019&min=50&type=avg_spin&hand=
// https://docs.google.com/spreadsheets/d/1fvZZfnSIZFhC8kCl7RTJmMfnbb7GRAPXs7FWSL2nQkg/edit#gid=1077179801&range=E1:E2
pitcherMlb.set(Enums.BaseballPitchType.Sinker.key, Enums.PitchData.Spin.key, 2191, 2878);

// https://baseballsavant.mlb.com/leaderboard/pitch-movement?year=2019&team=&min=q&pitch_type=SIFT&hand=&x=diff_x_hidden&z=diff_z_hidden&sort=6&sortDir=desc
// https://docs.google.com/spreadsheets/d/1wr1yUS6HXH_7intowlWHTlWoqEF1Ddq9vs97sKN5G6g/edit#gid=1975992683&range=O1:O2
// pitcherMlb.set(Enums.BaseballPitchType.Sinker.key, Enums.PitchData.BreakV.key, 22.7 * inchToM, 46.6 * inchToM);

// https://docs.google.com/spreadsheets/d/1giHZnyhB_JApDEjO6I9SAB04ISb20MYNrWPpTmSNf7w/edit#gid=534733429&range=Z1:Z3
pitcherMlb.set(Enums.BaseballPitchType.Sinker.key, Enums.PitchData.BreakV.key, -21.6 * inchToM, -26.5 * inchToM);

// https://baseballsavant.mlb.com/leaderboard/pitch-movement?year=2019&team=&min=q&pitch_type=SIFT&hand=&x=diff_x_hidden&z=diff_z_hidden&sort=9&sortDir=desc
// https://docs.google.com/spreadsheets/d/1wr1yUS6HXH_7intowlWHTlWoqEF1Ddq9vs97sKN5G6g/edit#gid=1975992683&range=S1:S2
// https://docs.google.com/spreadsheets/d/1giHZnyhB_JApDEjO6I9SAB04ISb20MYNrWPpTmSNf7w/edit#gid=534733429&range=Y1:Y3
pitcherMlb.set(Enums.BaseballPitchType.Sinker.key, Enums.PitchData.BreakH.key, 13.6 * inchToM, 16.8 * inchToM);

pitcherMlb.set(Enums.BaseballPitchType.Sinker.key, Enums.PitchData.SpinDirection.key, 120.7, 230.8);

// FC Cutter
// https://baseballsavant.mlb.com/pitch-arsenals?year=2019&min=50&type=avg_speed&hand=&sort=3&sortDir=desc
// https://docs.google.com/spreadsheets/d/1AYG2yeFzEVgrcCcpxjGnjrHlKfPzwt5O9ki3wliUBp4/edit#gid=45617823&range=F1:F2
pitcherMlb.set(Enums.BaseballPitchType.Cutter.key, Enums.PitchData.Speed.key, 88.9 * mphToMs, 99.2 * mphToMs);

// https://baseballsavant.mlb.com/pitch-arsenals?year=2019&min=50&type=avg_spin&hand=&sort=3&sortDir=desc
// https://docs.google.com/spreadsheets/d/1fvZZfnSIZFhC8kCl7RTJmMfnbb7GRAPXs7FWSL2nQkg/edit#gid=1077179801&range=F1:F2
pitcherMlb.set(Enums.BaseballPitchType.Cutter.key, Enums.PitchData.Spin.key, 2337, 2928);

// https://baseballsavant.mlb.com/leaderboard/pitch-movement?year=2019&team=&min=q&pitch_type=FC&hand=&x=diff_x_hidden&z=diff_z_hidden&sort=6&sortDir=desc
// https://docs.google.com/spreadsheets/d/1wr1yUS6HXH_7intowlWHTlWoqEF1Ddq9vs97sKN5G6g/edit#gid=1570903751&range=O1:O2
// pitcherMlb.set(Enums.BaseballPitchType.Cutter.key, Enums.PitchData.BreakV.key, 27.6 * inchToM, 41.6 * inchToM);

// https://docs.google.com/spreadsheets/d/1giHZnyhB_JApDEjO6I9SAB04ISb20MYNrWPpTmSNf7w/edit#gid=534733429&range=AD1:AD3
pitcherMlb.set(Enums.BaseballPitchType.Cutter.key, Enums.PitchData.BreakV.key, -27.1 * inchToM, -28.9 * inchToM);

// https://baseballsavant.mlb.com/leaderboard/pitch-movement?year=2019&team=&min=q&pitch_type=FC&hand=&x=diff_x_hidden&z=diff_z_hidden&sort=9&sortDir=desc
// https://docs.google.com/spreadsheets/d/1wr1yUS6HXH_7intowlWHTlWoqEF1Ddq9vs97sKN5G6g/edit#gid=1570903751&range=S1:S2
// https://docs.google.com/spreadsheets/d/1giHZnyhB_JApDEjO6I9SAB04ISb20MYNrWPpTmSNf7w/edit#gid=534733429&range=AC1:AC3
pitcherMlb.set(Enums.BaseballPitchType.Cutter.key, Enums.PitchData.BreakH.key, -1.3 * inchToM, -3.7 * inchToM);

pitcherMlb.set(Enums.BaseballPitchType.Cutter.key, Enums.PitchData.SpinDirection.key, 185.3, 245.7);

// SL Slider
// https://baseballsavant.mlb.com/pitch-arsenals?year=2019&min=50&type=avg_speed&hand=&sort=4&sortDir=desc
// https://docs.google.com/spreadsheets/d/1AYG2yeFzEVgrcCcpxjGnjrHlKfPzwt5O9ki3wliUBp4/edit#gid=45617823&range=G1:G2
pitcherMlb.set(Enums.BaseballPitchType.Slider.key, Enums.PitchData.Speed.key, 84.5 * mphToMs, 92.5 * mphToMs);

// https://baseballsavant.mlb.com/pitch-arsenals?year=2019&min=50&type=avg_spin&hand=&sort=4&sortDir=desc
// https://docs.google.com/spreadsheets/d/1fvZZfnSIZFhC8kCl7RTJmMfnbb7GRAPXs7FWSL2nQkg/edit#gid=1077179801&range=G1:G2
pitcherMlb.set(Enums.BaseballPitchType.Slider.key, Enums.PitchData.Spin.key, 2401, 3270);

// https://baseballsavant.mlb.com/leaderboard/pitch-movement?year=2019&team=&min=q&pitch_type=SL&hand=&x=diff_x_hidden&z=diff_z_hidden&sort=6&sortDir=desc
// https://docs.google.com/spreadsheets/d/1wr1yUS6HXH_7intowlWHTlWoqEF1Ddq9vs97sKN5G6g/edit#gid=1383237073&range=O1:O2
// pitcherMlb.set(Enums.BaseballPitchType.Slider.key, Enums.PitchData.BreakV.key, 37.3 * inchToM, 52.3 * inchToM);

// https://docs.google.com/spreadsheets/d/1giHZnyhB_JApDEjO6I9SAB04ISb20MYNrWPpTmSNf7w/edit#gid=534733429&range=N1:N3
pitcherMlb.set(Enums.BaseballPitchType.Slider.key, Enums.PitchData.BreakV.key, -39.2 * inchToM, -50 * inchToM);

// https://baseballsavant.mlb.com/leaderboard/pitch-movement?year=2019&team=&min=q&pitch_type=SL&hand=&x=diff_x_hidden&z=diff_z_hidden&sort=9&sortDir=desc
// https://docs.google.com/spreadsheets/d/1wr1yUS6HXH_7intowlWHTlWoqEF1Ddq9vs97sKN5G6g/edit#gid=1383237073&range=S1:S2
// https://docs.google.com/spreadsheets/d/1giHZnyhB_JApDEjO6I9SAB04ISb20MYNrWPpTmSNf7w/edit#gid=534733429&range=M1:M3
pitcherMlb.set(Enums.BaseballPitchType.Slider.key, Enums.PitchData.BreakH.key, -4.6 * inchToM, -12.7 * inchToM);

pitcherMlb.set(Enums.BaseballPitchType.Slider.key, Enums.PitchData.SpinDirection.key, 233.5, 327.4);

// CH Changeup
// https://baseballsavant.mlb.com/pitch-arsenals?year=2019&min=50&type=avg_speed&hand=&sort=5&sortDir=desc
// https://docs.google.com/spreadsheets/d/1AYG2yeFzEVgrcCcpxjGnjrHlKfPzwt5O9ki3wliUBp4/edit#gid=45617823&range=H1:H2
pitcherMlb.set(Enums.BaseballPitchType.Changeup.key, Enums.PitchData.Speed.key, 85.3 * mphToMs, 92.6 * mphToMs);

// https://baseballsavant.mlb.com/pitch-arsenals?year=2019&min=50&type=avg_spin&hand=&sort=5&sortDir=desc
// https://docs.google.com/spreadsheets/d/1fvZZfnSIZFhC8kCl7RTJmMfnbb7GRAPXs7FWSL2nQkg/edit#gid=1077179801&range=H1:H2
pitcherMlb.set(Enums.BaseballPitchType.Changeup.key, Enums.PitchData.Spin.key, 1774, 2732);

// https://baseballsavant.mlb.com/leaderboard/pitch-movement?year=2019&team=&min=q&pitch_type=CH&hand=&x=diff_x_hidden&z=diff_z_hidden&sort=6&sortDir=desc
// https://docs.google.com/spreadsheets/d/1wr1yUS6HXH_7intowlWHTlWoqEF1Ddq9vs97sKN5G6g/edit#gid=720595276&range=O1:O2
// pitcherMlb.set(Enums.BaseballPitchType.Changeup.key, Enums.PitchData.BreakV.key, 31.3 * inchToM, 53.2 * inchToM);

// https://docs.google.com/spreadsheets/d/1giHZnyhB_JApDEjO6I9SAB04ISb20MYNrWPpTmSNf7w/edit#gid=534733429&range=R1:R3
pitcherMlb.set(Enums.BaseballPitchType.Changeup.key, Enums.PitchData.BreakV.key, -30.7 * inchToM, -36.8 * inchToM);

// https://baseballsavant.mlb.com/leaderboard/pitch-movement?year=2019&team=&min=q&pitch_type=CH&hand=&x=diff_x_hidden&z=diff_z_hidden&sort=9&sortDir=desc
// https://docs.google.com/spreadsheets/d/1wr1yUS6HXH_7intowlWHTlWoqEF1Ddq9vs97sKN5G6g/edit#gid=720595276&range=S1:S2
// https://docs.google.com/spreadsheets/d/1giHZnyhB_JApDEjO6I9SAB04ISb20MYNrWPpTmSNf7w/edit#gid=534733429&range=Q1:Q3
pitcherMlb.set(Enums.BaseballPitchType.Changeup.key, Enums.PitchData.BreakH.key, 14.8 * inchToM, 17.5 * inchToM);

pitcherMlb.set(Enums.BaseballPitchType.Changeup.key, Enums.PitchData.SpinDirection.key, 120.5, 157.4);

// CU Curveball
// https://baseballsavant.mlb.com/pitch-arsenals?year=2019&min=50&type=avg_speed&hand=&sort=6&sortDir=desc
// https://docs.google.com/spreadsheets/d/1AYG2yeFzEVgrcCcpxjGnjrHlKfPzwt5O9ki3wliUBp4/edit#gid=45617823&range=I1:I2
pitcherMlb.set(Enums.BaseballPitchType.Curveball.key, Enums.PitchData.Speed.key, 78.9 * mphToMs, 87.2 * mphToMs);

// https://baseballsavant.mlb.com/pitch-arsenals?year=2019&min=50&type=avg_spin&hand=&sort=6&sortDir=desc
// https://docs.google.com/spreadsheets/d/1fvZZfnSIZFhC8kCl7RTJmMfnbb7GRAPXs7FWSL2nQkg/edit#gid=1077179801&range=I1:I2
pitcherMlb.set(Enums.BaseballPitchType.Curveball.key, Enums.PitchData.Spin.key, 2490, 3431);

// https://baseballsavant.mlb.com/leaderboard/pitch-movement?year=2019&team=&min=q&pitch_type=CUKC&hand=&x=diff_x_hidden&z=diff_z_hidden&sort=6&sortDir=desc
// https://docs.google.com/spreadsheets/d/1wr1yUS6HXH_7intowlWHTlWoqEF1Ddq9vs97sKN5G6g/edit#gid=202090489&range=O1:O2
// pitcherMlb.set(Enums.BaseballPitchType.Curveball.key, Enums.PitchData.BreakV.key, 54.9 * inchToM, 73.4 * inchToM);

// https://docs.google.com/spreadsheets/d/1giHZnyhB_JApDEjO6I9SAB04ISb20MYNrWPpTmSNf7w/edit#gid=534733429&range=V1:V3
pitcherMlb.set(Enums.BaseballPitchType.Curveball.key, Enums.PitchData.BreakV.key, 56.3 * inchToM, -69.5 * inchToM);

// https://baseballsavant.mlb.com/leaderboard/pitch-movement?year=2019&team=&min=q&pitch_type=CUKC&hand=&x=diff_x_hidden&z=diff_z_hidden&sort=9&sortDir=desc
// https://docs.google.com/spreadsheets/d/1wr1yUS6HXH_7intowlWHTlWoqEF1Ddq9vs97sKN5G6g/edit#gid=202090489&range=S1:S2
// https://docs.google.com/spreadsheets/d/1giHZnyhB_JApDEjO6I9SAB04ISb20MYNrWPpTmSNf7w/edit#gid=534733429&range=U1:U3
pitcherMlb.set(Enums.BaseballPitchType.Curveball.key, Enums.PitchData.BreakH.key, -7.2 * inchToM, -14.6 * inchToM);

pitcherMlb.set(Enums.BaseballPitchType.Curveball.key, Enums.PitchData.SpinDirection.key, 293, 343.4);

// FS Splitter
// https://baseballsavant.mlb.com/pitch-arsenals?year=2019&min=50&type=avg_speed&hand=&sort=7&sortDir=desc
// https://docs.google.com/spreadsheets/d/1AYG2yeFzEVgrcCcpxjGnjrHlKfPzwt5O9ki3wliUBp4/edit#gid=45617823&range=J1:J2
pitcherMlb.set(Enums.BaseballPitchType.Splitter.key, Enums.PitchData.Speed.key, 85.5 * mphToMs,  92.2 * mphToMs);

// https://baseballsavant.mlb.com/pitch-arsenals?year=2019&min=50&type=avg_spin&hand=&sort=7&sortDir=desc
// https://docs.google.com/spreadsheets/d/1fvZZfnSIZFhC8kCl7RTJmMfnbb7GRAPXs7FWSL2nQkg/edit#gid=1077179801&range=J1:J2
pitcherMlb.set(Enums.BaseballPitchType.Splitter.key, Enums.PitchData.Spin.key, 1503, 2275);

// https://baseballsavant.mlb.com/leaderboard/pitch-movement?year=2019&team=&min=q&pitch_type=FS&hand=&x=diff_x_hidden&z=diff_z_hidden&sort=6&sortDir=desc
// https://docs.google.com/spreadsheets/d/1wr1yUS6HXH_7intowlWHTlWoqEF1Ddq9vs97sKN5G6g/edit#gid=1978409066&range=O1:O2
// pitcherMlb.set(Enums.BaseballPitchType.Splitter.key, Enums.PitchData.BreakV.key, 32.4 * inchToM, 42.8 * inchToM);

// https://docs.google.com/spreadsheets/d/1giHZnyhB_JApDEjO6I9SAB04ISb20MYNrWPpTmSNf7w/edit#gid=534733429&range=AH1:AH3
// NA

// https://baseballsavant.mlb.com/leaderboard/pitch-movement?year=2019&team=&min=q&pitch_type=FS&hand=&x=diff_x_hidden&z=diff_z_hidden&sort=9&sortDir=desc
// https://docs.google.com/spreadsheets/d/1wr1yUS6HXH_7intowlWHTlWoqEF1Ddq9vs97sKN5G6g/edit#gid=1978409066&range=S1:S2
// https://docs.google.com/spreadsheets/d/1giHZnyhB_JApDEjO6I9SAB04ISb20MYNrWPpTmSNf7w/edit#gid=534733429&range=AG1:AG3
// pitcherMlb.set(Enums.BaseballPitchType.Splitter.key, Enums.PitchData.BreakH.key, 10.1 * inchToM, 14.8 * inchToM);

pitcherMlb.set(Enums.BaseballPitchType.Splitter.key, Enums.PitchData.SpinDirection.key, 145.5, 264.8);

// KN Knuckleball
// https://baseballsavant.mlb.com/pitch-arsenals?year=2019&min=50&type=avg_speed&hand=&sort=8&sortDir=desc
// https://docs.google.com/spreadsheets/d/1AYG2yeFzEVgrcCcpxjGnjrHlKfPzwt5O9ki3wliUBp4/edit#gid=45617823&range=K1:K2
// needed to mix avg with 2018, as there is only one player using that in 2019  => https://baseballsavant.mlb.com/pitch-arsenals?year=2018&min=50&type=avg_speed&hand=&sort=8&sortDir=desc
pitcherMlb.set(Enums.BaseballPitchType.Knuckleball.key, Enums.PitchData.Speed.key, (74.7 + 75.9) * mphToMs / 2, 74.7 * mphToMs);

// https://baseballsavant.mlb.com/pitch-arsenals?year=2019&min=50&type=avg_spin&hand=&sort=8&sortDir=desc
// https://docs.google.com/spreadsheets/d/1fvZZfnSIZFhC8kCl7RTJmMfnbb7GRAPXs7FWSL2nQkg/edit#gid=1077179801&range=K1:K2
// needed to mix avg with 2018, as there is only one player using that in 2019  => https://baseballsavant.mlb.com/pitch-arsenals?year=2018&min=50&type=avg_spin&hand=&sort=8&sortDir=desc
pitcherMlb.set(Enums.BaseballPitchType.Knuckleball.key, Enums.PitchData.Spin.key, (1441 + 1974) / 2, 1974);

// KC - Knuckle Curve is not available on leaderboard, but can be fetched from sqlite DB mlb_pitch_data_sqlite (mlb_pitch_data.db)
pitcherMlb.set(Enums.BaseballPitchType.KnuckleCurve.key, Enums.PitchData.Speed.key, 80.3 * mphToMs,  87.2 * mphToMs);

pitcherMlb.set(Enums.BaseballPitchType.KnuckleCurve.key, Enums.PitchData.Spin.key, 1292, 1860);

pitcherMlb.set(Enums.BaseballPitchType.KnuckleCurve.key, Enums.PitchData.SpinDirection.key, 291.5, 338.6);

// break - NA https://docs.google.com/spreadsheets/d/1giHZnyhB_JApDEjO6I9SAB04ISb20MYNrWPpTmSNf7w/edit#gid=534733429&range=AK1:AL3

export default pitcherMlb;